import React, { useEffect, useRef, useState,useMemo} from 'react';
import Nav from "../../components/Nav";
import Body from "../../components/Body";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useReport } from '../../state/reportsState';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { authenticatedFetch } from "../../state/apiUtils";
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { useParams } from 'react-router-dom';
import { msalInstance } from '../..';
import axios from 'axios';
import { useLocation } from "react-router-dom";
export default function Report() {
    const { id } = useParams();
    const reportTitle = "";
    const dt = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [globalFilter, setGlobalFilter] = useState(null);
    const [dataInCSV, setDataInCSV] = useState("");
    const [reportData, setReportData] = useState<any[]>([]);
    const [reportInfo, setReportInfo] = useState({
        ReportId: '',
        Name: '',
        Path: '',
        Columns: [],
        Filters: []
    });
    const [cols, setCols] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const pageSizeOptions: number[] = [100, 250,500,1000];
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(1);
    const toast = useRef<Toast>(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 100,
        page: 0,
        sortField: null,
        sortOrder: null,
        filters: {}
    });
type ReportFilter = {
    startDate: string | null;
    endDate: string | null;
    page: number;
    pageSize: number;
    filters: {
        label: string;
        value: string;
        matchMode: string;
    };
    fieldType:string;
    isInitialLoad:boolean;
};

const location = useLocation();
const auditType = location.pathname.split("/").pop();

console.log("Component is rendring here");

    // const reportFilter :ReportFilter = {
    //     startDate: null,
    //     endDate:null,
    //     page: page,
    //     pageSize: pageSize,
    //     filters:{
    //         label:'',
    //         value:''
    //     },
    //     fieldType:''
    // };
const [reportFilter, setReportFilter] = useState<ReportFilter>({
    startDate: null,
    endDate: null,
    page: 1,
    pageSize: 100,
    filters: {
        label: '',
        value: '',
        matchMode: FilterMatchMode.CONTAINS
    },
    fieldType: '',
    isInitialLoad:false
});

const [exporting, setExporting] = useState(false);
const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));

    useEffect(() => {
        loadReportInfo();
   loadReportData();
        
    }, []);

    useEffect(() => {
        loadReportData();
    }, [reportFilter]);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        AccountName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        PlanName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClientBankName: { value: null, matchMode: FilterMatchMode.CONTAINS  },
        CreatedDate: { value: null, matchMode: FilterMatchMode.CONTAINS  },
        LoanNumber: { value: null, matchMode: FilterMatchMode.EQUALS },
        BorrowersFirstName: { value: null, matchMode: FilterMatchMode.EQUALS },
        BorrowersLastName: { value: null, matchMode: FilterMatchMode.EQUALS },
        SampleSize: { value: null, matchMode: FilterMatchMode.EQUALS },
        Channel: { value: null, matchMode: FilterMatchMode.CONTAINS },
        AuditPlanStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
        LoanAmount: { value: null, matchMode: FilterMatchMode.CONTAINS },
        LoanType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        InvestorType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Investor: { value: null, matchMode: FilterMatchMode.CONTAINS },
        InvestorName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        FundingMonth: { value: null, matchMode: FilterMatchMode.CONTAINS },
        QCReviewMonth: { value: null, matchMode: FilterMatchMode.CONTAINS },
        LienPosition: { value: null, matchMode: FilterMatchMode.CONTAINS },
        LoanPurpose: { value: null, matchMode: FilterMatchMode.CONTAINS },
        RefinanceType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Terms: { value: null, matchMode: FilterMatchMode.CONTAINS },
        OccupancyType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        CreditScore: { value: null, matchMode: FilterMatchMode.CONTAINS },
        LTV: { value: null, matchMode: FilterMatchMode.CONTAINS },
        CLTV: { value: null, matchMode: FilterMatchMode.CONTAINS },
        CurrentState: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ExceptionReviewName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        InitialQCTestResults: { value: null, matchMode: FilterMatchMode.CONTAINS },
        FinalQCTestResults: { value: null, matchMode: FilterMatchMode.CONTAINS },
        DefectDetails: { value: null, matchMode: FilterMatchMode.CONTAINS },
        InitialSeverityRating: { value: null, matchMode: FilterMatchMode.CONTAINS },
        FinalSeverityRating: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ExceptionStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ExceptionStage: { value: null, matchMode: FilterMatchMode.CONTAINS },
        DefectCategory: { value: null, matchMode: FilterMatchMode.CONTAINS },
        DefectSubcategory: { value: null, matchMode: FilterMatchMode.CONTAINS },
        DefectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        AreaResponsible: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ResponsibleParty: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    // ← change null to undefined in types
const [sortField, setSortField] = useState<string | undefined>(undefined);
const [sortOrder, setSortOrder] = useState<1 | -1 | 0 | undefined>(undefined);

    // const getUSAIsoDate = () => {
    //     return `${new Date().toLocaleDateString("en-CA", {
    //         timeZone: "America/New_York"
    //     })}T00:00:00.000Z`;
    // };

    const getUSAIsoDate = () => {
    const now = new Date();
    const nyDate = now.toLocaleDateString("en-CA", { timeZone: "America/New_York" });

    const start = new Date(`${nyDate}T00:00:00`).toLocaleString("sv-SE", { timeZone: "America/New_York" });
    const startUTC = new Date(start).toISOString();

    const end = new Date(`${nyDate}T23:59:59`).toLocaleString("sv-SE", { timeZone: "America/New_York" });
    const endUTC = new Date(end).toISOString();

    return { start: startUTC, end: endUTC };
}

    const getPreviousMonthDateRange = () => {
    const today = new Date();

    // Previous month
    const prevMonth = today.getMonth() === 0 ? 11 : today.getMonth() - 1; // Jan -> Dec
    const year = prevMonth === 11 ? today.getFullYear() - 1 : today.getFullYear();

    // Start date: 1st day of previous month
    const startDate = new Date(Date.UTC(year, prevMonth, 1, 0, 0, 0));

    // End date: last day of previous month
    const endDate = new Date(Date.UTC(year, prevMonth + 1, 0, 23, 59, 59)); // day 0 = last day previous month

    return {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
    };
};

//the below loadReportData is old i've added the new function call inital loaded to show data ;
    const loadReportData = () => {
        reportCount();
        setLoading(true);
    const isInitialLoad =
        reportFilter.page === 1 &&
        !reportFilter.filters.label &&
        !reportFilter.filters.value &&
        !startDate &&
        !endDate;

    let payload = { ...reportFilter };

    payload.isInitialLoad = isInitialLoad;

    if (isInitialLoad) {

        if(auditType?.toLowerCase() === "postcloseauditplansmonthend" || auditType?.toLowerCase() === "prefundauditplansmonthend" || auditType?.toLowerCase() === "servicingauditplansmonthend"){

            const pervDate = getPreviousMonthDateRange();
            payload.startDate = pervDate.startDate;
            payload.endDate = pervDate.endDate;

            console.log("pervDate",pervDate);
            
        }else{
            const isoDate = getUSAIsoDate();
            payload.startDate = isoDate.start;
            payload.endDate = isoDate.end;
        }
        reportFilter.startDate = payload.startDate;
        reportFilter.endDate = payload.endDate;
    }

    // // If user selected startDate/endDate, overwrite payload
    if (startDate) payload.startDate = startDate;
    if (endDate) payload.endDate = endDate;

    // KEEP PREVIOUS DATES FOR PAGINATION
if (!payload.startDate && reportFilter.startDate) {
    payload.startDate = reportFilter.startDate;
}
if (!payload.endDate && reportFilter.endDate) {
    payload.endDate = reportFilter.endDate;
}
if (startDate || endDate) {
    payload.fieldType = 'dateRange'; // <-- new flag for backend
}


        authenticatedFetch(
            "/QcReports/data/" + id,
            {
                method: "POST",
                body: JSON.stringify(payload),
                headers: {
                    "Content-Type": "application/json",
               }
            })
            .then(res => {
                setReportData(res);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.current?.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'Oops! The server encountered an error. Please try again later. If the error persists please reach out to the site admin.', 
                    life: 5000 
                });
                console.error(error);
            });
    };

    const loadReportInfo = async () => {
        
        authenticatedFetch(
            "/QcReports/columns/" + id,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
               }
            })
            .then(res => {
                setCols(res);
            })
            .catch((error) => {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Oops! The server encountered an error. Please try again later. If the error persists please reach out to the site admin.', life: 5000 });
                console.error(error);
            });

        authenticatedFetch(
            "/QcReports/report/" + id,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
               }
            })
            .then(res => {
                setReportInfo(res);
            })
            .catch((error) => {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Oops! The server encountered an error. Please try again later. If the error persists please reach out to the site admin.', life: 5000 });
                console.error(error);
            });
            
    }

    const reportCount = () => {

        //console.log("reportFilter in count",startDate,endDate);
    const isInitialLoad =
    reportFilter.page === 1 &&
    !reportFilter.filters.label &&
    !reportFilter.filters.value &&
    !startDate &&
    !endDate;

let payload = { ...reportFilter };
payload.isInitialLoad = isInitialLoad;
// If initial load, set fallback date
    if (isInitialLoad) {
        if(auditType?.toLowerCase() === "postcloseauditplansmonthend" || auditType?.toLowerCase() === "prefundauditplansmonthend" || auditType?.toLowerCase() === "servicingauditplansmonthend"){

            const pervDate = getPreviousMonthDateRange();
            payload.startDate = pervDate.startDate;
            payload.endDate = pervDate.endDate;
            
        }else{
            const isoDate = getUSAIsoDate();
            payload.startDate = isoDate.start;
            payload.endDate = isoDate.end;
        }
    }

    // If user selected startDate/endDate, overwrite payload
    if (startDate) payload.startDate = startDate;
    if (endDate) payload.endDate = endDate;

    // KEEP PREVIOUS DATES FOR PAGINATION
if (!payload.startDate && reportFilter.startDate) {
    payload.startDate = reportFilter.startDate;
}
if (!payload.endDate && reportFilter.endDate) {
    payload.endDate = reportFilter.endDate;
}
if (startDate || endDate) {
    payload.fieldType = 'dateRange'; // <-- new flag for backend
}
// Exiting code 
    //     const payload = {
    //     ...reportFilter,
    //     startDate: startDate ?? reportFilter.startDate,
    //     endDate: endDate ?? reportFilter.endDate
    // };

        authenticatedFetch(
            "/QcReports/data/" + id + "/count",
            {
                method: "POST",
                body: JSON.stringify(payload),
                headers: {
                    "Content-Type": "application/json",
               }
            })
            .then(res => {
                setTotalRecords(res);
            })
            .catch((error) => {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Oops! The server encountered an error. Please try again later. If the error persists please reach out to the site admin.', life: 5000 });
                console.error(error);
            });
    };

    // const exportCSV = (selectionOnly: boolean) => {
    //     setLoading(true);
    //     authenticatedFetch(
    //         "/QcReports/data/" + id + "/csv",
    //         {
    //             method: "GET",
    //             headers: {
    //                 "Content-Type": "application/json",
    //            }
    //         })
    //         .then(res => {
    //             // ✅ Use res.data directly — don't rely on state here
    //             const csvData = res.data;
    //             setDataInCSV(csvData);
    //             console.log("dataInCSV",res.data);
    //             setLoading(false);
    //             const element = document.createElement('a');
    //             const file = new Blob([csvData], { type: 'text/csv' });
    //             element.href = URL.createObjectURL(file);
    //             element.download = 'data.csv';
    //             document.body.appendChild(element);
    //             element.click();

    //             // ✅ Clean up the object URL and element after use
    //             document.body.removeChild(element);
    //             URL.revokeObjectURL(element.href);
    //         })
    //         .catch((error) => {
    //             toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Oops! The server encountered an error. Please try again later. If the error persists please reach out to the site admin.', life: 5000 });
    //             console.error(error);
    //         });
    // };
    
//     const exportCSV = () => {
//     // ✅ Build same payload as loadReportData
//     const isInitialLoad =
//         reportFilter.page === 1 &&
//         !reportFilter.filters.label &&
//         !reportFilter.filters.value &&
//         !startDate &&
//         !endDate;

//     let payload = { ...reportFilter };
//     payload.isInitialLoad = isInitialLoad;

//     if (isInitialLoad) {
//         if (auditType?.toLowerCase() === "postcloseauditplansmonthend" || auditType?.toLowerCase() === "prefundauditplansmonthend") {
//             const pervDate = getPreviousMonthDateRange();
//             payload.startDate = pervDate.startDate;
//             payload.endDate = pervDate.endDate;
//         } else {
//             const isoDate = getUSAIsoDate();
//             payload.startDate = isoDate.start;
//             payload.endDate = isoDate.end;
//         }
//     }

//     // If user selected startDate/endDate, overwrite payload
//     if (startDate) payload.startDate = startDate;
//     if (endDate) payload.endDate = endDate;

//     // Keep previous dates
//     if (!payload.startDate && reportFilter.startDate) {
//         payload.startDate = reportFilter.startDate;
//     }
//     if (!payload.endDate && reportFilter.endDate) {
//         payload.endDate = reportFilter.endDate;
//     }

//     if (startDate || endDate) {
//         payload.fieldType = 'dateRange';
//     }

//     console.log("export payload", payload);

//     // ✅ POST request with filters in body
//     authenticatedFetch(
//         "/QcReports/data/" + id+"/csv",
//         {
//             method: "POST",
//             body: JSON.stringify(payload),
//             headers: {
//                 "Content-Type": "application/json",
//             }
//         })
//         .then(res => {
//             // ✅ Handle CSV file download
//             const blob = new Blob([res], { type: "text/csv" });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement("a");
//             link.href = url;
//             link.setAttribute("download", `${id}_export.csv`);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);
//         })
//         .catch((error) => {
//             toast.current?.show({
//                 severity: 'error',
//                 summary: 'Error',
//                 detail: 'Export failed. Please try again.',
//                 life: 5000
//             });
//             console.error(error);
//         });
// };
  const exportCSV = () => {
    setExporting(true); // Add loading state
    
    const isInitialLoad =
        reportFilter.page === 1 &&
        !reportFilter.filters.label &&
        !reportFilter.filters.value &&
        !startDate &&
        !endDate;

    let payload = { ...reportFilter };
    payload.isInitialLoad = isInitialLoad;

    if (isInitialLoad) {
        if (auditType?.toLowerCase() === "postcloseauditplansmonthend" || 
            auditType?.toLowerCase() === "prefundauditplansmonthend" || auditType?.toLowerCase() === "servicingauditplansmonthend") {
            const pervDate = getPreviousMonthDateRange();
            payload.startDate = pervDate.startDate;
            payload.endDate = pervDate.endDate;
        } else {
            const isoDate = getUSAIsoDate();
            payload.startDate = isoDate.start;
            payload.endDate = isoDate.end;
        }
    }

    if (startDate) payload.startDate = startDate;
    if (endDate) payload.endDate = endDate;

    if (!payload.startDate && reportFilter.startDate) {
        payload.startDate = reportFilter.startDate;
    }
    if (!payload.endDate && reportFilter.endDate) {
        payload.endDate = reportFilter.endDate;
    }

    if (startDate || endDate) {
        payload.fieldType = 'dateRange';
    }

   

    authenticatedFetch(
        "/QcReports/data/" + id + "/csv",
        {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
            }
        })
        .then(res => {
            //console.log("CSV Response:", res); 
            // // Debug: see response structure
            
            // ✅ FIX: Extract CSV string from response object
            let csvData;
            
            // Check if response has a 'result' property (common backend pattern)
            if (res && res.result) {
                csvData = res.result;
            } 
            // Or if it's directly a string
            else if (typeof res === 'string') {
                csvData = res;
            }
            // Or if it's in a 'data' property
            else if (res && res.data) {
                csvData = res.data;
            }
            else {
                throw new Error("Invalid CSV response format");
            }

            // ✅ Create blob from CSV string (not the object)
            const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${id}_export_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            // toast.current?.show({
            //     severity: 'success',
            //     summary: 'Success',
            //     detail: 'CSV exported successfully',
            //     life: 3000
            // });
        })
        .catch((error) => {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Export failed. Please try again.',
                life: 5000
            });
            console.error("Export error:", error);
        })
        .finally(() => {
            setExporting(false); // Re-enable button
        });
};    
const handleChangeStart = (event: any) => {
        setStartDate(event.target.value);
        console.log("startDate",startDate);
    }

    const handleChangeEnd = (event: any) => {
        setEndDate(event.target.value);
        console.log("endDate",endDate);
    }

    const onPage = (event: any) => {
        setPageSize(event.rows);
         setlazyState(event);
    setReportFilter(prev => ({
        ...prev,
        page: event.page + 1,
        pageSize: event.rows,
        startDate: prev.startDate,
        endDate: prev.endDate,
    }));
        //loadReportData();
    };

    const onGlobalFilterChange = (e: { target: { value: any; }; }) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
        console.log("filters",filters);
        console.log("globalFilterValue",globalFilterValue)
    };
    const onFilterChange = (e:any) => {
   
    const filtersObj = e.filters;
console.log("Filter filters", filtersObj);
    const activeFilter = Object.keys(filtersObj).find(
        key =>
            filtersObj[key]?.value !== null &&
            filtersObj[key]?.value !== ''
    );

    setReportFilter(prev => ({
        ...prev,
        page: 1, // reset to first page
        fieldType: activeFilter ? 'headerFilters' : '',
        filters: activeFilter
            ? {
                  label: activeFilter,
                  value: String(filtersObj[activeFilter].value),
                  matchMode: filtersObj[activeFilter].matchMode ?? FilterMatchMode.CONTAINS
              }
            : { label: '', value: '', matchMode: '' }
    }));

    console.log("reportFilter",reportFilter);
    console.log("activeFilter",activeFilter)

    //Loading purpose only comand the bewlo line and uncomment the above code to use the filter
    //loadReportData();
};

 const onSubmitDate = () => {

        // 🔴 Validation 1: Both dates required
        if (!startDate || !endDate) {
            toast.current?.show({
                severity: "error",
                summary: "Validation Error",
                detail: "Please select both Start Date and End Date.",
                life: 4000
            });
            return;
        }

        // 🔴 Validation 2: Start date should not be after End date
        if (startDate > endDate) {
            toast.current?.show({
                severity: "warn",
                summary: "Invalid Date Range",
                detail: "Start Date cannot be greater than End Date.",
                life: 4000
            });
            return;
        }

        // ✅ If validation passes
        loadReportData();
    };

// Add this sort handler
const onSort = (event: any) => {
    //console.log("Sorting by", event.sortField, "order", event.sortOrder);
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
};

// Add this memoized sorted data — sorts current page only
const sortedData = useMemo(() => {
    if (!sortField || !reportData.length) return reportData;

    return [...reportData].sort((a, b) => {
        const valA = a[sortField] ?? '';
        const valB = b[sortField] ?? '';

        if (typeof valA === 'number' && typeof valB === 'number') {
            return sortOrder === 1 ? valA - valB : valB - valA;
        }

        if (Date.parse(valA) && Date.parse(valB)) {
            return sortOrder === 1
                ? new Date(valA).getTime() - new Date(valB).getTime()
                : new Date(valB).getTime() - new Date(valA).getTime();
        }

        const strA = String(valA).toLowerCase();
        const strB = String(valB).toLowerCase();
        if (strA < strB) return sortOrder === 1 ? -1 : 1;
        if (strA > strB) return sortOrder === 1 ? 1 : -1;
        return 0;
    });
}, [reportData, sortField, sortOrder]);


//console.log("Inital load")
    const header = (
        <div className="flex align-items-center justify-content-end gap-2">
            Start Date:
            <Calendar value={startDate} onChange={handleChangeStart} />
            End Date:
            <Calendar value={endDate} onChange={handleChangeEnd} />
            {/* <Button type="button" onClick={() => loadReportData()}>Submit</Button> */}
            <Button type="button" onClick={() => onSubmitDate()}>Submit</Button>
            <div>
                {/* //<Button type="button" icon="pi pi-file" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" /> */}
                    {/* <Button type="button" icon="pi pi-file" rounded onClick={() => exportCSV()} data-pr-tooltip="CSV" /> */}
                        <Button type="button" icon="pi pi-file" disabled={reportData.length === 0} rounded onClick={() => exportCSV()} data-pr-tooltip="CSV" />
            </div>
        </div>
    );

    return (
        <div>
            <Toast ref={toast} position="top-right" />
            <Nav />
            <Body>
            <h1 className="m-0">{reportInfo.Name}</h1>
            <div style={{ height: 'calc(100vh - 120px)' }}>
            <DataTable ref={dt} 
                    //value={reportData}
                    value={sortedData}
                    scrollable scrollHeight="flex" tableStyle={{ minWidth: '25rem' }}
                    header={header} lazy 
                    onSort={onSort} sortField={sortField ?? undefined} sortOrder={sortOrder} 
                    onPage={onPage} loading={loading}
                    first={lazyState.first} totalRecords={totalRecords}
                    filters={filters} filterDisplay="row"  
                    onFilter={onFilterChange}
                    showGridlines stripedRows
                    paginator rowsPerPageOptions={pageSizeOptions} rows={pageSize} 
                    emptyMessage="No records found" alwaysShowPaginator={true} selectionMode="single"
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    >
                {cols.map((col, index) => (
                    <Column key={index} field={col.field} header={col.header} style={{ minWidth: col.width }} filter sortable />
                ))}
            </DataTable>
            </div>
            </Body>
        </div>
    )
}
